import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { SocialLinks } from "@/components/SocialLinks";
import { BUSINESS } from "@/lib/brand";
import { WA_MESSAGES, waLink } from "@/lib/api";

const Col = ({ title, children }) => (
  <div>
    <h4 className="text-[11px] uppercase tracking-[0.22em] text-[#D5B98C] mb-4">{title}</h4>
    <ul className="space-y-2.5 text-sm text-[#F5F0E8]/80">{children}</ul>
  </div>
);

const FLink = ({ to, children, testId }) => (
  <li><Link to={to} data-testid={testId} className="hover:text-[#D5B98C] transition-colors">{children}</Link></li>
);

const ExtLink = ({ href, children, testId }) => (
  <li><a href={href} data-testid={testId} target="_blank" rel="noopener noreferrer" className="hover:text-[#D5B98C] transition-colors">{children}</a></li>
);

export const Footer = () => (
  <footer className="relative grain bg-[#242321] text-[#F5F0E8] mt-24" data-testid="site-footer">
    <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 pt-16 pb-10 grid grid-cols-2 lg:grid-cols-6 gap-10">
      <div className="col-span-2">
        <Logo light size="footer" testId="footer-logo" />
        <address className="not-italic mt-6 text-sm text-[#F5F0E8]/70 leading-relaxed" data-testid="footer-address">
          {BUSINESS.address}<br />{BUSINESS.city}
        </address>
        <div className="mt-3 text-xs text-[#F5F0E8]/55" data-testid="footer-hours">
          {BUSINESS.hours.map((h) => <div key={h.days}>{h.days}: {h.time}</div>)}
        </div>
        <SocialLinks className="mt-6 text-[#F5F0E8]" prefix="footer-social" />
      </div>
      <Col title="Contatti">
        <ExtLink href={BUSINESS.phoneHref} testId="footer-phone-link">{BUSINESS.phone}</ExtLink>
        <ExtLink href={waLink(WA_MESSAGES.prodotto)} testId="footer-whatsapp-link">WhatsApp</ExtLink>
        <ExtLink href={`mailto:${BUSINESS.email}`} testId="footer-email-link">{BUSINESS.email}</ExtLink>
        <FLink to="/contatti" testId="footer-link-contatti">Pagina contatti</FLink>
      </Col>
      <Col title="Assistenza">
        <FLink to="/faq" testId="footer-link-faq">FAQ</FLink>
        <FLink to="/spedizioni" testId="footer-link-spedizioni">Spedizioni e consegne</FLink>
        <FLink to="/resi" testId="footer-link-resi">Resi e diritto di recesso</FLink>
        <FLink to="/pagamenti" testId="footer-link-pagamenti">Pagamenti</FLink>
      </Col>
      <Col title="Boutique">
        <FLink to="/collezione" testId="footer-link-collezione">Collezione</FLink>
        <FLink to="/chi-siamo" testId="footer-link-chi-siamo">Chi siamo</FLink>
        <FLink to="/admin/login" testId="footer-link-admin">Area riservata</FLink>
      </Col>
      <Col title="Legale">
        <FLink to="/termini" testId="footer-link-termini">Termini e condizioni di vendita</FLink>
        <FLink to="/privacy" testId="footer-link-privacy">Privacy Policy</FLink>
        <FLink to="/cookie" testId="footer-link-cookie">Cookie Policy</FLink>
      </Col>
    </div>
    <div className="relative border-t border-[#F5F0E8]/10">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 py-5 flex flex-col lg:flex-row gap-3 justify-between text-xs text-[#F5F0E8]/50 leading-relaxed">
        <span data-testid="footer-legal-info">
          © {new Date().getFullYear()} {BUSINESS.brand} è il marchio e-commerce di {BUSINESS.legalName}, {BUSINESS.legalForm} · Sede legale {BUSINESS.legalSeat} · P.IVA {BUSINESS.vat} · C.F. {BUSINESS.cf} · REA {BUSINESS.rea} · PEC {BUSINESS.pec}
        </span>
        <a data-testid="footer-historic-site-link" href="https://www.iltuocalzolaio.it" target="_blank" rel="noopener noreferrer" className="hover:text-[#D5B98C] shrink-0">
          Il nostro sito storico: www.iltuocalzolaio.it
        </a>
      </div>
    </div>
  </footer>
);
